export default __webpack_public_path__ + "static/char-v-48-b3ae226e13c342d9cc1a3b3152392af9.webp";